module.exports = __webpack_public_path__ + "img/magic-3-step.c7f86c08.png";